import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { GlobalService } from '../_services/global.service';
import { ConfigPermissionOption } from '../_helpers/config-permission-option';
@Injectable()
export class AuthScanAccountManagementGuard implements CanActivate {
    public configPermissionOption = ConfigPermissionOption;
    constructor(private globalService: GlobalService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let checkPermission = this.globalService.canPermission(this.configPermissionOption.actionScanAccountManagement);
        if (!checkPermission) {
            this.router.navigate(['/dashboard']);
        } else {
            return true;
        }
        return false;
    }
}
@Injectable()
export class AuthSeedingAccountManagerGuard implements CanActivate {
    public configPermissionOption = ConfigPermissionOption;
    constructor(private globalService: GlobalService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let checkPermission = this.globalService.canPermission(this.configPermissionOption.actionSeedingAccountManager);
        if (!checkPermission) {
            this.router.navigate(['/dashboard']);
        } else {
            return true;
        }
        return false;
    }
}
@Injectable()
export class AuthVPSHostingManagementGuard implements CanActivate {
    public configPermissionOption = ConfigPermissionOption;
    constructor(private globalService: GlobalService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let checkPermission = this.globalService.canPermission(this.configPermissionOption.actionVPSHostingManagement);
        if (!checkPermission) {
            this.router.navigate(['/dashboard']);
        } else {
            return true;
        }
        return false;
    }
}
@Injectable()
export class AuthTokenManagementGuard implements CanActivate {
    public configPermissionOption = ConfigPermissionOption;
    constructor(private globalService: GlobalService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let checkPermission = this.globalService.canPermission(this.configPermissionOption.actionTokenManagement);
        if (!checkPermission) {
            this.router.navigate(['/dashboard']);
        } else {
            return true;
        }
        return false;
    }
}
@Injectable()
export class AuthPriorityListManagementGuard implements CanActivate {
    public configPermissionOption = ConfigPermissionOption;
    constructor(private globalService: GlobalService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let checkPermission = this.globalService.canPermission(this.configPermissionOption.actionPriorityListManagement);
        if (!checkPermission) {
            this.router.navigate(['/dashboard']);
        } else {
            return true;
        }
        return false;
    }
}

@Injectable()
export class AuthNewsAnalyticConfigGuard implements CanActivate {
    public configPermissionOption = ConfigPermissionOption;
    constructor(private globalService: GlobalService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let checkPermission = this.globalService.canPermission(this.configPermissionOption.actionConfigNewsAnalytic);
        if (!checkPermission) {
            this.router.navigate(['/dashboard']);
        } else {
            return true;
        }
        return false;
    }
}





// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_guards/auth-group-account-management.guard.ts